import { useEffect, useState } from 'react'
import './policies.css'
import { privacyPolicy, termsAndConditions } from '../../utils/constants/PolicyContent'
import MFLogo from "../../assets/nav-icons/kfin-logo.svg";
import { Link, useLocation } from 'react-router-dom'
import { NavList } from '../../utils/constants/navigation';

const Policies = () => {

    const location = useLocation()
    const [policyMode, setPolicyMode] = useState(true)
    const currentYear = new Date().getFullYear()

    useEffect(() => {
        if (location.pathname === NavList.PRIVACY_POLICIES) {
            setPolicyMode(true)
        } else {
            setPolicyMode(false)
        }
    }, [])

    return (
        <div className='mf-policy-section'>
            <div className="policy-header primary-bg-color">
                <div className="policy-header-content">
                    <Link to={'/'}><img src={MFLogo} alt="mf central" /> </Link>
                </div>
            </div>
            <div className="py-4 policy-title-container bg-white">
                {/* <strong className='w-700 text-capitalize text-sec-color policy-title'>{policyMode ? 'Privacy policy' : 'Terms of use'}</strong> */}
                {/* <span className="policy-hero-brand">FINFABRIK</span> */}
                <div className="policy-hero-title">
                    <h1 className="mb-0">{policyMode ? 'PRIVACY POLICY' : 'TERMS OF USE'}</h1>
                </div>
            </div>
            <div className="mf-policy-content-container mb-4 mt-1">
                <div className="mf-policy-content font-14 text-primary-color p-3" dangerouslySetInnerHTML={{ __html: policyMode ? privacyPolicy : termsAndConditions }} />
            </div>
            <div className="policy-footer">
                <p className="mb-1">&copy; KFin Technologies Ltd. All rights reserved.</p>
                <p className="mb-0">Last updated: July {currentYear}</p>
            </div>
        </div>
    )
}

export default Policies
